import ApiService from '@/services/apiService';
import { mapMutations, mapState, mapGetters } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'ViewISFMAccess',
  data: function () {
    return {
      accessItemsUI: [],
      favType: 'accessMgmt'
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    })
  },
  mounted() {
    this.getAccessObjects();
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    getAccessObjects() {
      return ApiService.isFmAccessFetchByUserId(this.sessionUserId).then(data => {
        this.accessItemsUI = data;
        this.checkAccessObjects();
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('IS.FM.AccessMgmt.errorFetchingAccess'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    },
    keyTwinTitle(item) {
      return `${get(item, 'dtwinData.title')} (${get(item, 'parentData.title')})`;
    },
    checkAccessObjects() {
      this.accessItemsUI.forEach(element => {
        try {
          if (!element.accessObjectData.data.isFm.doorId) {
            this.$snack(`
              ${this.$i18n_t('IS.FM.AccessMgmt.errorDoorConf')}
              ${element.accessObjectData.title}
            `, 'error');
          }
        } catch (e) {
          this.$snack(e, 'error');
        }
      });
    }
  }
};